import React from 'react';
import { Row } from 'react-bootstrap';

export const DisplayVendorStatus = (props) => {
    return (
      <div>
        <p className="vendorStatus">{props.text}</p>
      </div>
    );
  };
  
  export const Status = (props) => {
    return (
      <Row>
        {props.statusValue != null
          ? Object.values(props.statusValue).map((status, index) => {
              return (
                <label key={index} htmlFor={status.replace(" ", "")} className={props.style}>
                  {status !== "" && (
                    <input
                      type={props.fieldType}
                      id={status.replace(" ", "")}
                      name={
                        props.fieldType === "radio" ||
                        props.fieldType === "checkbox"
                          ? props.radioGrp
                          : status.replace(" ", "")
                      }
                      value={status}
                      onClick={(e) => props.onStatusChange(e, props.statusId)}
                      checked={props.getSelectedStatus(
                        status,
                        props.statusId,
                        props.fieldType
                      )}
                      disabled={props.disableElement}
                    />
                  )}
                  {status}
                </label>
              );
            })
          : null}
      </Row>
    );
  };
  
  export const TextArea = ({
    id,
    placeHolderText,
    style,
    noOfRows,
    onChangeHandler,
    disabled,
    value,
  }) => {
    return (
      <div>
        <textarea
          placeholder={placeHolderText}
          rows={noOfRows}
          className={style}
          id={id}
          maxLength="200"
          onChange={onChangeHandler}
          value={value}
          disabled={disabled}
        />
      </div>
    );
  };
  